import { useContext } from 'react';
import { DialogCtx } from './context';

const useDialog = () => {
  const { setDialog } = useContext(DialogCtx);

  return {
    setDialog,
  };
};

export default useDialog;
